import { useQuery } from "@tanstack/react-query";
import { getCmsPageByTypeAPI, type PageType } from "../api/cms";
import { useTranslation } from "react-i18next";

const cleanQuillContent = (html: string): string => {
  if (!html) return "";

  return html
    .replace(/<span class="ql-ui" contenteditable="false"><\/span>/g, "")
    .replace(/<p>\s*<\/p>/g, "")
    .replace(/<li>\s*<\/li>/g, "")
    .trim();
};

export const useCmsPage = (pageType: PageType) => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const {
    data: cmsData,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery({
    queryKey: ["cms-page", pageType, currentLanguage],
    queryFn: () => getCmsPageByTypeAPI(pageType),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  let page = null;
  if (cmsData?.data) {
    const pageData = cmsData.data;
    page = {
      id: pageData._id,
      pageType: pageData.pageType,
      title: pageData.title,
      content: cleanQuillContent(pageData.content),
      createdAt: pageData.createdAt,
      updatedAt: pageData.updatedAt,
    };
  }

  return {
    page,
    isLoading,
    isError,
    error: error as Error,
    refetch,
  };
};
